import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "./Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";

const ADMIN_ROLES = ["super_admin", "admin", "sub_admin"];

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (!ADMIN_ROLES.includes(data.user.role)) {
        setError("This account does not have admin access.");
        setLoading(false);
        return;
      }
      login(data.token, data.user);
      toast.success(`Welcome, ${data.user.name}`);
      navigate("/admin");
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Admin Login" subtitle="Secure access for VIRIKS administrators">
      <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
        <div className="flex items-center gap-2 text-sm text-muted-foreground bg-muted rounded-md px-3 py-2">
          <ShieldCheck size={16} className="text-amber" /> Restricted area — authorized staff only
        </div>
        <div><Label>Email</Label><Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@viriks.com" data-testid="admin-login-email" required /></div>
        <div><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="admin-login-password" required /></div>
        {error && <p className="text-crimson text-sm" data-testid="admin-login-error">{error}</p>}
        <Button type="submit" className="w-full viriks-navy text-white" disabled={loading} data-testid="admin-login-submit">{loading ? "Signing in..." : "Login to Admin Panel"}</Button>
      </form>
    </AuthShell>
  );
}
